<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>
  <site-modal
    ID="sessionsInformationModal"
    modalSize="medium"
    @closed="closeSessionsInformation"
  >
    <template #header>
      <h6>
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-info-square"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          ></path>
          <path
            d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
          ></path>
        </svg>
        راهنما
      </h6>
    </template>
    <template #body>
      <div>
        <p class="justified">
          مراجع گرامی، راهنمای استفاده از انواع تست‌ها به شرح زیر می‌باشد:
        </p>
        <p class="justified">
          <strong>1. تست دامنه توجه IVA-2:</strong>
          جلسات ارزیابی دامنه توجه به دو صورت حضوری و غیرحضوری برگزار می‌شود. در
          جلسات حضوری علاوه بر مصاحبه تشخیصی توسط متخصص روانشناس، تست کامپیوتری
          بسیار معتبر IVA-2 نیز اجرا خواهد شد. در جلسات غیرحضوری متخصص مربوطه با
          شما مصاحبه بالینی دقیقی را انجام می‌دهد و طبق دستورالعمل‌ها، تک به تک
          علائم را با شما چک می‌کند و نهایتا نتیجه تشخیص و راه حل درمانی مشکل را
          خدمتت شما ارائه خواهد داد. این تست برای کودکان پنج سال تا افراد هشتاد
          سال قابل اجراست و نتیجه تست حضوری با مصاحبه غیرحضوری از لحاظ دقت
          تشخیصی و بالینی تفاوتی ندارد.
        </p>
        <p class="justified">
          <strong>2. تست قصه عشق LSS:</strong>
          یک ابزار بسیار مفید برای خودشناسی و انتخاب دقیق در روابط عاطفی محسوب
          می شود که براساس جدیدترین نظریه رابرت استرنبرگ روانشناس مشهور آمریکایی
          در زمینه روابط عاطفی طراحی و ساخته شده است. این تست مختص افراد ۱۸ سال
          به بالا هست. تعداد سوالات این تست ۱۰۰ و زمان تقریبی پاسخدهی به آن ۲۵
          دقیقه می باشد.
        </p>

        <p class="justified">
          <strong>3. تست اختلالات روانی MMPI:</strong>
          جامع ترین و معروفترین تست در روانشناسی محسوب می شود که اطلاعات بسیار
          دقیقی در زمینه ابعاد مختلف شخصیت و وضعیت سلامت روان در اختیار قرار می
          دهد. این تست برای افراد ۱۶ سال به بالا قابل اجرا می باشد. تعداد سوالات
          این تست ۵۶۷ و زمان تقریبی پاسخدهی به آن ۶۰ دقیقه است.
        </p>
        <p class="justified">
          <strong>4. تست اختلالات شخصیت MCMI:</strong>
          بصورت اختصاصی در زمینه تشخیص اختلالات شخصیت طراحی شده و خروجی بسیار
          دقیقی از انواع مختلف اختلالات شخصیت در اختیار متخصص بالینی قرار می
          دهد‌. این تست مناسب افراد ۱۸ سال به بالا است. تعداد سوالات این تست ۱۷۵
          و زمان تقریبی پاسخدهی به آن ۳۰ دقیقه است.
        </p>
        <p class="justified">
          <strong>5. تست شخصیت شناسی NEO:</strong>
          آزمون بسیار مشهور در زمینه سنجش پنج فاکتور اصلی شخصیت است. کاربرد اصلی
          این تست شخصیت شناسی و خودشناسی در زمینه روابط پیش از ازدواج و پیشرفت
          شغلی می باشد. این تست برای افراد ۱۷ تا ۷۹ سال مناسب است. تعداد سوالات
          این تست ۲۴۰ و زمان تقریبی پاسخدهی به آن ۱۵ دقیقه می باشد.
        </p>
        <p class="justified">
          <strong>6. تست شخصیت CATTELL:</strong>
          این تست ارزیابی جامعی از شانزده عامل شخصیت به عمل می آورد و اصلی ترین
          کاربرد آن تشخیص بالینی و طراحی مداخلات درمانی، مشاوره شغلی و پیش از
          ازدواج است. این تست برای افراد ۱۶ سال و بالاتر کاربرد دارد. تعداد
          سوالات این تست ۱۸۷ و زمان تقریبی پاسخدهی به آن ۲۰ دقیقه می باشد.
        </p>

        <p class="justified">
          <strong>7. تست طرحواره یانگ:</strong>
          یکی از معتبرترین تستها در زمینه سنجش و تشخیص طرحواره های ناسازگاز یا
          تله های زندگی است که توسط روانشناس معروف جفری یانگ طراحی و ابداع شده
          است. این تست برای افراد ۱۲ سال و بالاتر از آن کاربرد دارد. تعداد
          سوالات این تست ۹۰ و زمان تقریبی پاسخدهی به آن ۱۵ دقیقه می باشد.
        </p>

        <p class="justified">
          <strong>8. تست نیازهای گلاسر:</strong>
          یک آزمون بسیار کاربردی براساس تئوری انتخاب روانشناس معروف ویلیام گلاسر
          است که نیازهای اساسی پنج‌گانه افراد را شناسایی می کند و بین متخصصان
          سلامت روان در زمینه ارتقای روابط بین فردی، عاطفی و مشاوره پیش از
          ازدواج ابزاری کارآمد محسوب می شود. این تست برای افراد ۱۳ و بالاتر از
          آن کاربرد دارد. تعداد سوالات این تست ۳۵ و زمان تقریبی پاسخدهی به آن ۱۵
          دقیقه می باشد.
        </p>
        <p class="justified">
          <strong>9. تست فرزندپروری یانگ:</strong>
          این تست براساس نظریه طرحواره درمانی جفری یانگ و در زمینه ارزیابی سبک
          های مختلف فرزندپروری طراحی شده است. در واقع متخصص روانشناس به کمک این
          تست می تواند به ریشه های تحولی طرحواره های ناسازگار مراجع خویش آگاهی
          پیدا کند. این تست برای افراد ۱۲ سال و بالاتر از آن کاربرد دارد. تعداد
          سوالات این تست ۷۲ و زمان تقریبی پاسخدهی به آن ۱۵ دقیقه می باشد.
        </p>
        <p class="justified">
          <strong>10. تست هوش هیجانی (EQ):</strong>
          بارون، استاد روانشناسی دانشگاه تگزاس، یکی از پیشگامان سنجش هوش هیجانی
          (EQ) در دنیا محسوب می شود که با طراحی تست EQi پنج بعد کلی هوش هیجانی و
          پانزده فاکتور حیاتی در تنظیم احساسات و هیجانات را شناسایی کرد. کاربرد
          اصلی این تست آشنایی متخصصان و مراجعین نسبت به ابعاد متخلف هوش هیجانی
          در وجود خود و رشد و توسعه نقاط ضعف در این زمینه می باشد. این تست برای
          افراد ۱۸ سال و بالاتر از آن مناسب است. تعداد سوالات این تست ۹۰ و زمان
          تقریبی پاسخدهی به آن ۱۵ دقیقه می باشد.
        </p>
        <p class="justified">
          <strong>11. تست هوش گاردنر(کودک):</strong>
          دکتر گاردنر تکیه صرف بر ضریب هوشی در کودکان را گمراه کننده می پندارد و
          معتقد است هر کدام از کودکان ابعاد مختلف و متفاوتی از هوش و استعداد را
          دارا هستند. تست هوش چندگانه گاردنر یکی از معتبرترین ابزارهای هوش در
          سطح دنیا در زمینه سنجش هوش و استعداد شغلی و تحصیلی در کودکان می باشد.
          این تست برای کوکان ۷ تا ۱۲ سال کاربرد دارد. تعداد سوالات این تست ۴۸ و
          زمان تقریبی پاسخگویی ۳۰ دقیقه است.
        </p>

        <p class="justified">
          <strong>12. تست هوش گاردنر (نوجوان و بزرگسال):</strong>
          از طریق این تست می توانید نه جنبه مختلف هوش خود را شناسایی و با کمک
          متخصص مربوطه در زمینه ارتقای ابعاد مختلف هوش تمرینات لازم را انجام
          دهید. کاربرد اصلی این تست در زمینه استعدادیابی در زمینه های شغلی و
          تحصیلی است. حداقل سن لازم برای انجام این تست ۱۲ سال است. تعداد سوالات
          این تست ۸۰ و زمان تقریبی پاسخگویی ۳۰ دقیقه است.
        </p>

        <p class="justified">
          <strong>13. رغبت سنج شغلی و تحصیلی هالند:</strong>
          روانشناس مشهور آمریکایی جان هالند شش حوزه اصلی در ارزیابی علاقه ها و
          تمایلات شغلی افراد شناسایی کرد. شما براساس اینکه در کدامیک از این شش
          طبقه قرار می گیرید به لحاظ شخصیتی متناسب با شغل و حرفه خاصی هستید که
          نتایج این تست بهترین طبقه شغلی برای شما را معرفی می نماید. این تست
          برای افراد ۱۲ سال و بالاتر مناسب است و انجام تکالیف و چالش های ارائه
          شده در این تست حدودا ۱۵ دقیقه زمان می برد.
        </p>
      </div>
    </template>
    <template #footer>
      <div class="m-auto">
        <button
          class="btn btn-sm rounded btn-blueSite"
          @click="closeSessionsInformation"
        >
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
      </div>
    </template>
  </site-modal>
  <div class="px-3">
    <div
      class="mb-3"
      :style="[isMobile ? { '': '' } : { 'min-height': '50vh' }]"
    >
      <div class="mb-3 mt-1">
        <div class="accordion m-auto col-lg-5 col-md-6">
          <div class="accordion-item h-100">
            <div class="accordion-header p-2">
              <h6 class="m-0">نام تست و شیوه برگزاری را انتخاب نمایید:</h6>
            </div>
            <div class="accordion-collapse collapse show">
              <div class="accordion-body">
                <div class="m-auto">
                  <div>
                    <searchable-input
                      :disabled="this.$store.getters.isOverseas == true"
                      :required="true"
                      mode="single"
                      placeHolder="شیوه برگزاری را انتخاب کنید..."
                      errorText="انتخاب شیوه برگزاری الزامی است."
                      ref="sessionTypeSelect"
                      :options="sessionTypeList"
                      v-model:inputValue="entity.sessionTypeID"
                      :canDeselect="false"
                      :canClear="false"
                      topTitle="شیوه برگزاری:"
                      inputTitle=""
                      topTitleClass="mb-1"
                      containerClass="my-1"
                      @multiSelectChanged="sessionTypeChanged"
                    />
                  </div>
                  <div>
                    <searchable-input
                      mode="single"
                      ref="testTypeInput"
                      errorText="انتخاب نام تست الزامی است."
                      placeHolder="نام تست را انتخاب نمایید..."
                      :required="true"
                      :options="testTypeList"
                      v-model:inputValue="entity.testTypeID"
                      :hasSideBox="false"
                      topTitle="نام تست:"
                      :canDeselect="false"
                      topTitleClass="mt-1"
                      :disabled="this.entity.sessionTypeID == 0"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center text-md-start nextStepLeft">
      <!-- قیمت جلسات -->
      <button
        class="btn btn-sm btn-light-blue"
        @click="sessionPricesInfo('test')"
        :class="isMobile ? 'px-1 ms-1 me-0' : ''"
      >
        <span> تعرفه </span>
      </button>
      <button
        class="btn btn-sm btn-warning"
        @click="openSessionsInformation()"
        :class="isMobile ? 'px-1 ms-1 me-0' : ''"
      >
        <span> راهنما </span>
      </button>
      <a
        class="btn btn-sm btn-danger"
        href="https://www.aparat.com/v/sff3k44"
        :class="isMobile ? 'px-1 ms-1 me-0' : ''"
        target="_blank"
      >
        <span>{{ isMobile ? 'فیلم آموزشی' : 'فیلم نحوه ثبت تست' }}</span>
      </a>
      <!-- گام بعدی -->
      <button
        class="btn btn-sm btn-blueSite"
        @click="nextTab()"
        :class="isMobile ? 'px-1 me-0' : ''"
      >
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-calendar-range"
          viewBox="0 0 16 16"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
            ></path>
          </svg>
        </svg>
        <span> گام بعدی </span>
      </button>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import SearchableInput from '../../../../../components/form/searchableInput/SearchableInput.vue';
import { Modal } from 'bootstrap';

export default {
  components: {
    LoadingSpinner,
    SearchableInput,
  },
  inject: ['nextStep', 'sessionPricesInfo'],
  data() {
    return {
      sessionsInformationModal: new Object(),
      isMobile: isMobile,
      sessionTypeList: [],
      originalTestTypeList: [],
      testTypeList: [],
      entity: {
        testTypeID: 0,
        sessionTypeID: 0,
      },
    };
  },
  props: {
    entityObject: {
      sessionTypeID: 0,
      topicIDs: [],
    },
  },
  methods: {
    openSessionsInformation() {
      this.sessionsInformationModal.show();
    },
    closeSessionsInformation() {
      this.sessionsInformationModal.hide();
    },
    nextTab() {
      let isPass = true;
      //مقدار شیوه برگزاری الزامی است
      if (this.entity.sessionTypeID == 0) {
        isPass = false;
        this.$refs.sessionTypeSelect.showErrorMessage();
      }

      //مقدار نام تست المزامی است
      if (!this.entity.testTypeID || this.entity.testTypeID == 0) {
        isPass = false;
        this.$refs.testTypeInput.showErrorMessage();
      }
      if (!isPass) return;
      localStorage.setItem(
        'testName',
        this.testTypeList.find((i) => i.id == this.entity.testTypeID)?.label
      );
      this.nextStep(
        new Object({
          sessionTypeID: this.entity.sessionTypeID,
          topicIDs: [this.entity.testTypeID],
        }),
        'selectTestSession'
      );
    },
    async getTestTypeList() {
      let that = this;
      this.isLoadingTopicList = true;
      await axios
        .post('/Basic/Topic/GetPublicByScopeIDs', [7])
        .then((response) => {
          that.originalTestTypeList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات نام تست‌ها با خطا مواجه گردید.`,
          });
        })
        .finally(() => {});
    },
    async getSessionTypeList() {
      let that = this;
      await axios
        .get('Basic/SessionType/GetPublic')
        .then((response) => {
          that.sessionTypeList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات انواع برگزاری با خطا مواجه گردید.`,
          });
        });
    },
    sessionTypeChanged(id) {
      this.entity.testTypeID = 0;
      if (id == 1) {
        let ids = [137, 188];
        this.testTypeList = this.originalTestTypeList.filter(
          (m) => ids.indexOf(m.id) >= 0
        );
      }

      if (id == 2) {
        let ids = [137, 188, 199];
        this.testTypeList = this.originalTestTypeList.filter(
          (m) => ids.indexOf(m.id) >= 0
        );
        ids = [124, 125, 126, 128, 129, 201, 202, 203, 209, 210, 211];
        let items = this.originalTestTypeList.filter(
          (m) => ids.indexOf(m.id) >= 0
        );
        this.testTypeList = this.testTypeList.concat(items);
      }
    },
    registerVideoLink() {
      let url = '';
      if (this.isMobile) {
        if (this.$store.getters.isOverseas == true) {
          url = 'https://aparat.com/v/yir08vd';
        } else {
          url = 'https://aparat.com/v/fbpcc90';
        }
      } else {
        if (this.$store.getters.isOverseas == true) {
          url = 'https://www.aparat.com/v/zyad214';
        } else {
          url = 'https://www.aparat.com/v/sff3k44';
        }
      }
      return url;
    },
  },
  async mounted() {
    await this.getTestTypeList();
    await this.getSessionTypeList();
    this.sessionsInformationModal = new Modal(
      document.getElementById('sessionsInformationModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.entity.testTypeID = this.entityObject.topicIDs[0] ?? 0;
    this.entity.sessionTypeID = this.entityObject.sessionTypeID ?? 0;
    if (this.$store.getters.isOverseas) {
      this.entity.sessionTypeID = 2;
      this.sessionTypeChanged(this.entity.sessionTypeID);
    }
  },
};
</script>
<style scoped>
.accordion-header,
.accordion-button,
.collapsed {
  color: white;
  background-color: #4c5e74;
  border-radius: 5px 5px 0px 0px;
}
</style>
